import { useSelector } from "react-redux";

const LandingPages = () => {

  return (
    <>
      <div className="iframe-div">
        <iframe
          title="Report Section"
          width="600"
          height="373.5"
          src="https://iiplwork.retool.com/embedded/public/6e21a42a-4dd9-4ee4-930e-b18e69290a71"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
};

export default LandingPages;
